module.exports = __webpack_public_path__ + "img/copy.1c44b097.svg";